import ssoProviders from '../../components/login/sso_providers'
import handleSaml from '../../components/login/handle_saml'

export default async function login (state, appOptions) {
  const Login = (await import(/* webpackChunkName: 'login' */ '../../components/login')).default

  // If we're already logged in, go back or default
  if (state.loggedIn) {
    state.changePage(state.defaultPage)
    return
  }

  const sso = {
    providers: ssoProviders({
      role: state.get('role'),
      finishedCallback: () => state.get('session').start()
    })
  }

  const view = new Login({
    model: state.get('session'),
    signupEnabled: appOptions.allowSignups,
    showNavigation: state.get('role') === 'participant',
    tabProfile: state.get('role'),
    activeTab: state.get('page'),
    sso,
    showInfoMessage: state.get('role') === 'agave',
    outOfBand: state.get('role') === 'agave'
  })

  view.on('click:signup', () => {
    state.changePage('signup')
  })

  view.on('click:reset', () => {
    state.changePage('reset_password')
  })

  view.on('click:saml-provider', (event) => {
    handleSaml({
      role: state.get('role'),
      url: event.detail.url
    })
  })

  return view
}
